export default {"src":"/_next/static/media/information.199cb1ca.svg","height":569,"width":644};